<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="search.name" placeholder="姓名/账号" class="filter-item" style="width: 300px;" @keyup.enter.native="handleFilter"/>
      <el-select v-model="search.status" placeholder="状态" class="filter-item" style="width: 130px" clearable>
        <el-option v-for="item in option.status" :key="item.key" :label="item.val" :value="item.key"/>
      </el-select>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>
      <el-button type="primary" class="filter-item" style="margin-left: 10px;" icon="el-icon-edit" @click="handleCreate">添加</el-button>
    </div>

    <el-table v-loading="listLoading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="姓名" align="center" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账号">
        <template slot-scope="scope">
          <span>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-tooltip content="编辑" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleEdit(scope.row)">
              <svg-icon icon-class="edit"/>
            </el-button>
          </el-tooltip>
          <el-tooltip content="重置密码" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleReset(scope.row)">
              <svg-icon icon-class="password"/>
            </el-button>
          </el-tooltip>
          <el-tooltip content="删除" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleDelete(scope.row)">
              <svg-icon icon-class="delete"/>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog class="dia" :title="!temp.id? '添加': '编辑'" :visible.sync="dia.edit">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="80px" style="max-width: 400px; margin-left:50px;">
        <el-form-item label="账号" prop="code" v-if="!temp.id">
          <el-input v-model="temp.code" placeholder="请填写账号，添加后不可修改"/>
        </el-form-item>
        <el-form-item label="密码" prop="pwd" v-if="!temp.id">
          <el-input :type="passwordType" v-model="temp.pwd" placeholder="请填写密码"/>
          <span class="show-pwd" @click="showPwd">
            <svg-icon icon-class="eye" />
          </span>
          </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="temp.name" placeholder="请填写名称"/>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" v-for="(row, idx) in option.status" :key="idx" :label="row.key">{{ row.val }}</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dia.edit = false">取消</el-button>
        <el-button type="primary" @click="saveData">确定</el-button>
      </div>
    </el-dialog>
    <!-- edit -->

    <el-dialog :visible.sync="dia.reset" title="重置密码" width="500px">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="80px" style="max-width: 350px; margin-left:50px;">
        <el-form-item label="账号">
          {{ temp.code }}
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-input :type="passwordType" v-model="temp.pwd" placeholder="请填写密码"/>
          <span class="show-pwd" @click="showPwd">
            <svg-icon icon-class="eye" />
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dia.reset = false">取消</el-button>
        <el-button type="primary" @click="resetPwd">确定</el-button>
      </div>
    </el-dialog>
    <!-- reset -->

  </div>
</template>

<script>
/* eslint-disable */
import waves from '@/directive/waves'

const option = {
  status: [{key: '1', val: '可用'}, {key: '0', val: '禁用'}]
}

export default {
  name: 'AdminTeam',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      let data = option.status.find(row => row.key == key)
      return data.val || '-'
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      search: {
        page: 1,
        size: 12,
        name: '',
        role: '',
        status: ''
      },
      option: option,
      dia: {
        edit: false,
        reset: false
      },
      passwordType: 'password',
      temp: {},

      rules: {
        name: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        code: [{ required: true, message: '请填写账号', trigger: 'blur' }],
        pwd: [{ required: true, message: '请填写密码', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const _t = this
      _t.listLoading = true
      _t.$http.post('/api/auth/', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    },
    handleCreate() {
      this.temp = {}
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleEdit(row) {
      this.temp = Object.assign({}, row)
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleDelete(row) {
      const _t = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          id: row.id
        }
        _t.$http.post('/api/auth/del', data).then(function(resp) {
          if (resp.code === 0) {
            _t.$message.success(resp.msg)
            const index = _t.list.indexOf(row)
            _t.list.splice(index, 1)
          }
        })
      })
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    saveData() {
      const _t = this
      _t.$refs['dataForm'].validate((valid) => {
        if (valid) {
          _t.$http.post('/api/auth/save', _t.temp).then(function(resp) {
            if (resp.code === 0) {
              _t.$message.success(resp.msg)
              _t.dia.edit = false
              _t.getList()
            }
          })
        }
      })
    },
    handleReset(row) {
      this.temp = Object.assign({}, row) // copy obj
      this.dia.reset = true
      this.passwordType = 'password'
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    resetPwd() {
      const _t = this
      _t.$refs['dataForm'].validate((valid) => {
        if (valid) {
          _t.$http.post('/api/auth/reset-pwd', _t.temp).then(function(resp) {
            if (resp.code === 0) {
              _t.$message.success(resp.msg)
              _t.dia.reset = false
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dia {
  .tip {
    color: $dark;
    font-size: 12px;
  }
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 0;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
</style>

